import * as React from 'react';
import Panel from './Panel';
import {MapSelector} from './MapSelector';
import {MapOption} from './AppTypes';
import {GameModeName} from './common/modes/GameMode';

interface StartGameProps {
    modeName: GameModeName;
    mapName?: string;
    maps?: MapOption[];
    onSetGameMode: (modeName: GameModeName) => void;
    onSelectMap: (mapName: string) => void;
    onStart: () => void;
}

export class StartGame extends React.Component<StartGameProps> {
    public render(): JSX.Element {
        const {mapName, onSelectMap, onStart}: StartGameProps = this.props;
        return (
            <Panel id="start-panel">
                <p>Start a game</p>
                <p className="instructions button-after">Choose a game mode</p>
                <button
                    type="button"
                    onClick={this.setClassic}
                    className={this.props.modeName === 'classic' ? 'selected' : 'unselected'}
                >
                    Classic
                </button>
                <button
                    type="button"
                    onClick={this.setFfa}
                    className={this.props.modeName === 'ffa' ? 'selected' : 'unselected'}
                >
                    FFA
                </button>
                <p className="instructions">Choose a map</p>
                <MapSelector value={mapName} maps={this.mapsForMode()} onSelect={onSelectMap} />
                <button type="button" onClick={onStart}>
                    Start
                </button>
            </Panel>
        );
    }

    private setClassic = () => {
        this.props.onSetGameMode('classic');
    };

    private setFfa = () => {
        this.props.onSetGameMode('ffa');
    };

    private mapsForMode(): MapOption[] {
        return (this.props.maps || []).filter(map => map.modeName === this.props.modeName);
    }
}



// WEBPACK FOOTER //
// ./src/StartGame.tsx